export default {
  TableHeadCryptoAccount: [
    [
      {
        displayName: 'cryptoAccount.tableHead.name',
      },
      {
        displayName: 'cryptoAccount.tableHead.network',
      },
      {
        displayName: 'cryptoAccount.tableHead.currency',
      },
      {
        displayName: 'cryptoAccount.tableHead.qrcode',
      },
      {
        displayName: 'cryptoAccount.tableHead.edit',
      },
      {
        displayName: 'cryptoAccount.tableHead.delete',
      },
    ],
  ],
};
